import { RingProgress } from "@ant-design/plots";

function RingProgressChart({
    middleTitle = "Test",
    color = "green",
    subColor,
    percent
}) {
    const config = {
        percent: percent || 1,
        color: [color, subColor || color],
        innerRadius: 0.85,
        radius: 0.98,
        statistic: {
            title: {
                style: {
                    fontWeight: "400",
                    fontSize: "14px",
                    color: "#94A3B8"
                },
                formatter: () => "Target Size"
            },
            content: {
                style: {
                    color: "#2B3674",
                    fontWeight: "700",
                    fontSize: "24px",
                    lineHeight: "32px"
                },
                formatter: () => middleTitle
            }
        }
    };
    return (
        <div className="ring-progress-chart" style={{ height: "98%", width: "98%", paddingTop: "1mm" }}>
            <RingProgress {...config} />
        </div>
    );
}
export default RingProgressChart;
